import { ajaxRequest } from './ajaxRequest.js';
import { incaAccessor } from './incaAccessor.js';
/**
 * Error containing a problem details.
 */ export class ProblemDetailsError extends Error {
    /** Problem details instance. */ problemDetails;
    /** Create a new instance by passing a problem details in the constructor. */ constructor(pd){
        super(JSON.stringify(pd));
        this.problemDetails = pd;
    }
}
const JSON_REGEXP = /application\/json/;
export const createAjaxError = (reason, message)=>({
        message: message,
        errors: [
            {
                reason: reason,
                message: message
            }
        ]
    });
export const getOrCreateAjaxError = (reason, data)=>{
    if (typeof data === 'string') {
        return createAjaxError(reason, data);
    }
    if (data.error) {
        return data.error;
    }
    return createAjaxError(reason, data.message || data.Message || 'Ett AJAX-fel uppstod.');
};
/**
 * Invokes a /api URL on INCA.
 *
 * @returns {Promise}
 */ export const apiRequest = async (url, options)=>{
    /**
     * REST-flöden har sin egen apiRequest som är tillgänglig via parametern "inca". Den är dock inte alltid
     * tillgänglig beroende på var/hur koden körs.
     *
     * Som en workaround kollar vi globalThis.restflow_apiRequest. På så vis kan man i sina REST-flöden sätta den.
     */ if (typeof globalThis.restflow_apiRequest !== 'undefined') {
        return globalThis.restflow_apiRequest(url, {
            method: options?.method || 'GET',
            body: options?.json
        });
    }
    let baseUrl = '/';
    const inca = incaAccessor();
    if (inca && inca.getBaseUrl) {
        baseUrl = inca.getBaseUrl();
    } else if (globalThis && globalThis.top && globalThis.top.baseUrl) {
        // No inca-object is available in overview boxes.
        baseUrl = globalThis.top.baseUrl;
    }
    try {
        const res = await ajaxRequest(`${baseUrl}api${url}`, options);
        if (res.status === 204) {
            // @ts-expect-error TODO
            return;
        }
        const contentType = res.headers.get('content-type') || '';
        const isJsonContent = JSON_REGEXP.test(contentType);
        if (isJsonContent) {
            const data = await res.json();
            if (res.ok) {
                return data;
            } else {
                if (data.error) {
                    data.error.status = res.status;
                }
                throw data;
            }
        }
        if (res.ok) {
            // @ts-expect-error TODO
            return res.text();
        } else if (contentType.startsWith('application/problem+json')) {
            throw new ProblemDetailsError(await res.json());
        } else {
            throw new Error(res.statusText);
        }
    } catch (err) {
        if (err instanceof ProblemDetailsError) {
            throw err;
        }
        throw getOrCreateAjaxError('AjaxError', err);
    }
};
